import { maintenancePlanningApi } from '../apis/api';
// import sampleFile from '../public/sample.xlsx';
import * as XLSX from "xlsx";


/* ========================================================= 
   API BASE PREFIX 
========================================================= */
console.log("🔍 Maintenance Planning Base URL:", maintenancePlanningApi.defaults.baseURL);
console.log("🔍 API Prefix:", "/v1/uat_mntplan/maintenance_planning");
const API_PREFIX = "/v1/uat_mntplan/maintenance_planning";

/* ========================================================= 
   UTILITY: Convert File to Base64 
========================================================= */
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove the "data:...;base64," prefix to get just the base64 string
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

/* ========================================================= 
   IMPROVED ERROR HANDLER UTILITY 
========================================================= */
const handleApiError = (error, fallbackMessage) => {
  // 🔍 DEBUG: Log the complete error structure
  console.log("🔍 ERROR HANDLER - Full error object:", error);
  console.log("🔍 ERROR HANDLER - error.response:", error.response);
  console.log("🔍 ERROR HANDLER - error.response?.data:", error.response?.data);
  console.log("🔍 ERROR HANDLER - error.response?.status:", error.response?.status);

  // If backend sent structured error (our new format)
  if (error.response?.data?.status === "error") {
    console.log("✅ Backend sent structured error - passing through");
    // Backend error is already in the right format
    throw error;
  }

  // Check if response exists (server responded)
  if (error.response) {
    const status = error.response.status;
    const data = error.response.data;

    console.log(`🔍 Server responded with status: ${status}`);
    console.log("🔍 Response data:", data);

    // If backend sent validation error with detail object
    if (data?.detail) {
      const detail = data.detail;

      // Check if detail is an object with validation errors
      if (typeof detail === "object" && detail.errors) {
        console.log("✅ Found validation errors object");
        throw {
          response: {
            data: {
              status: "error",
              message: detail.message || "Validation Failed",
              help: "Please fix the errors in your file and try again.",
              details: detail,
              error_type: "validation_errors"
            }
          }
        };
      }

      // Simple string error from backend
      if (typeof detail === "string") {
        console.log("✅ Found string error from backend");
        throw {
          response: {
            data: {
              status: "error",
              message: detail,
              help: "Please check your file and try again.",
              error_type: "api_error"
            }
          }
        };
      }
    }

    // 400 Bad Request - usually file/validation errors
    if (status === 400) {
      console.log("⚠️ 400 Bad Request - treating as validation error");
      throw {
        response: {
          data: {
            status: "error",
            message: data?.message || "Invalid file or data",
            help: data?.help || "Please check your file format and data. Download the sample file to see the correct format.",
            details: data?.details || data,
            error_type: data?.error_type || "validation_error"
          }
        }
      };
    }

    // 401 Unauthorized
    if (status === 401) {
      throw {
        response: {
          data: {
            status: "error",
            message: "Authentication required",
            help: "Please log in again.",
            error_type: "auth_error"
          }
        }
      };
    }

    // 404 Not Found
    if (status === 404) {
      throw {
        response: {
          data: {
            status: "error",
            message: "Resource not found",
            help: "The requested data could not be found. Please try again.",
            error_type: "not_found"
          }
        }
      };
    }

    // 500 Server Error
    if (status >= 500) {
      throw {
        response: {
          data: {
            status: "error",
            message: "Server error",
            help: "The server encountered an error. Please try again later.",
            error_type: "server_error"
          }
        }
      };
    }

    // Other server errors with response
    console.log("⚠️ Unknown server error");
    throw {
      response: {
        data: {
          status: "error",
          message: fallbackMessage,
          help: "An error occurred on the server. Please try again.",
          error_type: "server_error"
        }
      }
    };
  }

  // Network errors (no response from server)
  console.log("❌ No response from server - network error");
  throw {
    response: {
      data: {
        status: "error",
        message: "Connection failed",
        help: "Please check the format and inserted data in the file.",
        error_type: "network_error"
      }
    }
  };
};

/* ========================================================= 
   DOWNLOAD SAMPLE EXCEL
   GET /api/files/sample_excel_file 
========================================================= */
// Remove this import
// import sampleFile from '../public/sample.xlsx';

/* ========================================================= 
   DOWNLOAD SAMPLE EXCEL
   GET /api/files/sample_excel_file 
========================================================= */
/* ========================================================= 
   DOWNLOAD SAMPLE EXCEL (HARDCODED)
========================================================= */
const handleDownloadSample = () => {
  try {
    // Hardcoded sample data for Maintenance Planning
  const data = [
  {
    "Calendar Week": "2026/16",
    "Planned Date": "15-04-2026",
    "Functional Location": "4300-EQ-ECH-ECH01-CLCS",
    "Maintenance Plan": "2000047860",
    "MaintPlan dscrptn": "ECH CLIMATE CONTROL SYSTEM - RH",
    "MaintActivityType": "PRM",
    "Due Packages": "2C 5H",
    "Group": "43000226",
    "Group Counter": "1",
    "Completion date": ""
  },
  {
    "Calendar Week": "2026/16",
    "Planned Date": "15-04-2026",
    "Functional Location": "4300-EQ-ECH-ECH01-CSYS",
    "Maintenance Plan": "2000047860",
    "MaintPlan dscrptn": "ECH CLIMATE CONTROL SYSTEM - RH",
    "MaintActivityType": "PRM",
    "Due Packages": "2C",
    "Group": "43000214",
    "Group Counter": "1",
    "Completion date": ""
  }
];


    const filename = "Maintenance_Planning_Sample.xlsx";

    // Create Excel workbook
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample Data");
    
    // Generate Excel file
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    
    // Create download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up
    URL.revokeObjectURL(url);

    console.log("File downloaded successfully");
  } catch (error) {
    console.error("Sample download failed:", error);
  }
};


/* ========================================================= 
   FILE VALIDATION UTILITY 
========================================================= */
const validateFile = (file) => {
  console.log("🔍 Validating file:", file);
  const errors = [];
  const allowedExtensions = ['.xlsx', '.xls', '.csv'];
  const maxSize = 10 * 1024 * 1024; // 10MB

  // Check if file exists
  if (!file) {
    errors.push("Please select a file to upload");
    return { isValid: false, errors };
  }

  // Validate filename exists
  if (!file.name || file.name.trim() === '') {
    errors.push("File must have a valid name");
  }

  // Validate file extension
  const fileName = file.name.toLowerCase();
  const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
  if (!hasValidExtension) {
    errors.push(`Invalid file format. Please upload: ${allowedExtensions.join(', ')}`);
  }

  // Validate file has an extension
  if (!fileName.includes('.')) {
    errors.push("File must have an extension (.xlsx, .xls, or .csv)");
  }

  // Validate file size (not empty)
  if (file.size === 0) {
    errors.push("File is empty. Please select a valid file");
  }

  // Validate file size (not too large)
  if (file.size > maxSize) {
    const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
    errors.push(`File size (${sizeMB}MB) exceeds maximum limit of 10MB`);
  }

  // Check file type/MIME type
  const validMimeTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-excel', // .xls
    'text/csv', // .csv
    'application/octet-stream' // Generic binary (some systems use this)
  ];

  if (file.type && !validMimeTypes.includes(file.type)) {
    console.warn(`⚠️ Unexpected MIME type: ${file.type}`);
    // Don't add to errors - just warn, as extension check is more reliable
  }

  const isValid = errors.length === 0;
  console.log(isValid ? "✅ File validation passed" : "❌ File validation failed");
  if (!isValid) {
    console.log("Validation errors:", errors);
  }

  return { isValid, errors };
};

/* ========================================================= 
   UPLOAD INPUT FILE
   POST /api/files/input_upload
   Returns: { batch_id, rows_inserted, status, filename }
   🚨 IMPORTANT: For AWS Lambda, files must be base64 encoded
========================================================= */
const handleUploadFile = async (file) => {
  console.log("📤 UPLOAD STARTED");
  console.log("File object:", file);

  // ✅ VALIDATE FILE FIRST
  const validation = validateFile(file);
  if (!validation.isValid) {
    console.error("❌ File validation failed:", validation.errors);
    throw {
      response: {
        data: {
          status: "error",
          message: "File validation failed",
          help: "Please check the following issues with your file:",
          error_type: "validation_error",
          details: {
            errors: validation.errors,
            uploaded_file: file?.name || "No file selected",
            file_size: file?.size ? `${(file.size / 1024).toFixed(2)} KB` : "Unknown",
            allowed_formats: ['.xlsx', '.xls', '.csv'],
            max_size: "10 MB"
          }
        }
      }
    };
  }

  try {
    // Convert file to base64
    console.log("🔄 Converting file to base64...");
    const base64File = await fileToBase64(file);

    // ✅ VALIDATE BASE64 CONVERSION
    if (!base64File || base64File.trim() === '') {
      console.error("❌ Base64 conversion failed - empty result");
      throw {
        response: {
          data: {
            status: "error",
            message: "File conversion failed",
            help: "The file could not be processed. Please try a different file or contact support.",
            error_type: "conversion_error"
          }
        }
      };
    }

    console.log("✅ Base64 conversion successful");
    console.log("Base64 length:", base64File.length);
    console.log("Filename:", file.name);

    // ✅ VALIDATE BASE64 FORMAT (basic check)
    if (!base64File.match(/^[A-Za-z0-9+/]*={0,2}$/)) {
      console.error("❌ Invalid base64 format");
      throw {
        response: {
          data: {
            status: "error",
            message: "File encoding failed",
            help: "The file could not be properly encoded. Please try again.",
            error_type: "encoding_error"
          }
        }
      };
    }

    // Prepare JSON payload for Lambda
    const payload = {
      base64File: base64File,
      filename: file.name.trim() // Ensure filename is trimmed
    };

    console.log("📦 Sending payload to Lambda:", {
      filename: payload.filename,
      base64Length: payload.base64File.length,
      originalFileSize: file.size
    });

    // ✅ USE maintenancePlanningApi instead of AxiosWrapper
    const response = await maintenancePlanningApi.post(
      `${API_PREFIX}/input_upload`,
      payload
    );

    console.log("✅ Upload successful:", response.data);

    // Success response
    return response.data; // { batch_id, rows_inserted, status, filename }

  } catch (error) {
    console.error("❌ File upload failed:", error);

    // Log for debugging
    if (error.response) {
      console.error("STATUS:", error.response.status);
      console.error("DATA:", error.response.data);
    }

    // If it's already a formatted error, re-throw it
    if (error.response?.data?.status === "error") {
      throw error;
    }

    // Handle and re-throw with proper structure
    handleApiError(error, "File upload failed. Please check your file format and try again.");
  }
};

/* ========================================================= 
   START PROCESS
   POST /api/files/process_records?batch_id=...
   Returns: { status, message, rows_processed }
========================================================= */
const handleStartProcess = async (batchId) => {
  if (!batchId) {
    throw {
      response: {
        data: {
          status: "error",
          message: "Batch ID missing",
          help: "Please upload a file first to get a batch ID",
          error_type: "missing_batch_id"
        }
      }
    };
  }

  try {
    // ✅ USE maintenancePlanningApi instead of AxiosWrapper
    const response = await maintenancePlanningApi.post(
      `${API_PREFIX}/process_records?batch_id=${batchId}`,
      {}
    );

    return response.data; // { status, message, rows_processed }

  } catch (error) {
    console.error("Process failed:", error);

    // Check for specific error types
    if (error.response?.status === 404) {
      throw {
        response: {
          data: {
            status: "error",
            message: "Batch not found",
            help: "The batch ID is invalid or has expired. Please upload the file again.",
            error_type: "batch_not_found",
            details: { batch_id: batchId }
          }
        }
      };
    }

    if (error.response?.status === 409) {
      throw {
        response: {
          data: {
            status: "error",
            message: "Batch already processed",
            help: "This file has already been processed. Please upload a new file or download the results.",
            error_type: "already_processed",
            details: { batch_id: batchId }
          }
        }
      };
    }

    handleApiError(error, "Failed to process data");
  }
};

/* ========================================================= 
   DOWNLOAD OUTPUT FILE
   GET /api/files/output_export?batch_id=...
========================================================= */
const handleDownloadFile = async (batchId) => {
  if (!batchId) {
    throw {
      response: {
        data: {
          status: "error",
          message: "Batch ID missing",
          help: "Please upload and process a file first",
          error_type: "missing_batch_id"
        }
      }
    };
  }

  try {
    // ✅ USE maintenancePlanningApi instead of AxiosWrapper
    const response = await maintenancePlanningApi.get(
      `${API_PREFIX}/output_export`,
      {
        params: { batch_id: batchId },
        responseType: "blob"
      }
    );

    console.log("=== DOWNLOAD DEBUG START ===");
    console.log("Response headers:", response.headers);
    console.log("Response data type:", response.data.constructor.name);
    console.log("Response data size:", response.data.size);
    console.log("Response data MIME type:", response.data.type);

    let finalBlob;
    let filename = `bgt_planning_weekly_${batchId}.xlsx`;

    // Read the blob as text to check if it's JSON
    const text = await response.data.text();
    console.log("Blob content length:", text.length);
    console.log("First 500 chars:", text.substring(0, 500));

    const trimmedText = text.trim();

    // Check if it's JSON
    if (trimmedText.startsWith('{') || trimmedText.startsWith('[')) {
      try {
        const jsonData = JSON.parse(text);
        console.log("✅ Parsed JSON successfully");
        console.log("JSON keys:", Object.keys(jsonData));

        // Check for error response
        if (jsonData.status === "error" || jsonData.error) {
          throw { response: { data: jsonData } };
        }

        let base64Data = null;

        // AWS Lambda specific: Check if response has statusCode and body
        if (jsonData.statusCode && jsonData.body) {
          console.log("Detected AWS Lambda response format");

          // Body might be a string that needs parsing
          if (typeof jsonData.body === 'string') {
            try {
              const bodyObj = JSON.parse(jsonData.body);
              console.log("Parsed body keys:", Object.keys(bodyObj));

              // Look for base64 in the parsed body
              const bodyFields = ['base64File', 'file', 'data', 'base64', 'content', 'fileContent', 'excel_file'];
              for (const field of bodyFields) {
                if (bodyObj[field]) {
                  base64Data = bodyObj[field];
                  console.log(`✅ Found base64 in body.${field}`);
                  break;
                }
              }

              // Also check for filename in body
              if (bodyObj.filename) {
                filename = bodyObj.filename;
              }
            } catch (e) {
              // Body is not JSON, might be pure base64
              console.log("Body is not JSON, treating as base64 string");
              if (jsonData.body.match(/^[A-Za-z0-9+/]+=*$/)) {
                base64Data = jsonData.body;
              }
            }
          }
        } else {
          // Direct JSON response (not Lambda wrapped)
          const possibleFields = ['base64File', 'file', 'data', 'base64', 'body', 'content', 'fileContent', 'excel_file'];
          for (const field of possibleFields) {
            if (jsonData[field]) {
              base64Data = jsonData[field];
              console.log(`✅ Found base64 in jsonData.${field}`);
              break;
            }
          }

          // Extract filename if provided
          if (jsonData.filename) {
            filename = jsonData.filename;
          }
        }

        if (!base64Data) {
          console.error("❌ No base64 field found in JSON response");
          console.error("Available JSON structure:", JSON.stringify(jsonData, null, 2).substring(0, 1000));
          throw new Error("Invalid response format: no file data found");
        }

        // Clean up base64 string
        let cleanBase64 = base64Data.trim();

        // Remove data URI scheme if present
        if (cleanBase64.includes(',')) {
          const parts = cleanBase64.split(',');
          cleanBase64 = parts[parts.length - 1];
          console.log("✅ Removed data URI prefix");
        }

        // Remove any whitespace, newlines, carriage returns
        cleanBase64 = cleanBase64.replace(/[\s\n\r\t]/g, '');

        console.log("Clean base64 length:", cleanBase64.length);
        console.log("First 100 chars:", cleanBase64.substring(0, 100));
        console.log("Last 50 chars:", cleanBase64.substring(cleanBase64.length - 50));

        // Validate base64 format
        if (!cleanBase64.match(/^[A-Za-z0-9+/]*={0,2}$/)) {
          console.error("❌ Invalid base64 format detected");
          throw new Error("Invalid base64 format");
        }

        // Decode base64 to binary
        console.log("🔄 Decoding base64...");
        const binaryString = atob(cleanBase64);
        console.log("✅ Decoded binary length:", binaryString.length);

        // Convert binary string to Uint8Array
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        // Verify it's a valid Excel file (check magic number)
        const header = bytes.slice(0, 4);
        const magicNumber = Array.from(header)
          .map(b => b.toString(16).padStart(2, '0'))
          .join('');

        console.log("File magic number:", magicNumber);

        // Excel files (XLSX) start with PK (50 4B) - it's a ZIP file
        if (magicNumber !== "504b0304" && magicNumber !== "504b0506") {
          console.warn("⚠️ WARNING: File magic number doesn't match XLSX format!");
          console.warn("Expected: 504b0304 or 504b0506");
          console.warn("Got:", magicNumber);
          console.warn("First 20 bytes:", Array.from(bytes.slice(0, 20)));
        } else {
          console.log("✅ Valid XLSX file magic number detected");
        }

        // Create final blob
        finalBlob = new Blob([bytes], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

      } catch (jsonError) {
        if (jsonError.response) {
          throw jsonError;
        }
        console.error("❌ JSON parse error:", jsonError);
        console.log("Treating response as binary data");
        finalBlob = response.data;
      }
    } else if (trimmedText.match(/^[A-Za-z0-9+/]+=*$/)) {
      // Pure base64 string (no JSON wrapper)
      console.log("✅ Detected pure base64 string (no JSON wrapper)");

      const cleanBase64 = trimmedText.replace(/[\s\n\r\t]/g, '');
      console.log("Pure base64 length:", cleanBase64.length);

      const binaryString = atob(cleanBase64);
      console.log("Decoded binary length:", binaryString.length);

      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Check magic number
      const header = bytes.slice(0, 4);
      const magicNumber = Array.from(header)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');

      console.log("File magic number:", magicNumber);

      if (magicNumber !== "504b0304" && magicNumber !== "504b0506") {
        console.warn("⚠️ WARNING: Not a valid XLSX file format");
      } else {
        console.log("✅ Valid XLSX file magic number");
      }

      finalBlob = new Blob([bytes], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
    } else {
      // Not JSON, not base64, treat as binary Excel file directly
      console.log("✅ Treating as raw binary Excel data");
      finalBlob = response.data;
    }

    if (!finalBlob) {
      console.error("❌ finalBlob is null or undefined");
      throw new Error("Failed to process file data");
    }

    // Check Content-Disposition header for filename
    const contentDisposition = response.headers?.['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
        console.log("✅ Filename from header:", filename);
      }
    }

    console.log("✅ Final blob size:", finalBlob.size, "bytes");
    console.log("✅ Final filename:", filename);

    if (finalBlob.size === 0) {
      console.error("❌ Blob size is 0!");
      throw new Error("File is empty after processing");
    }

    console.log("=== DOWNLOAD DEBUG END ===");

    // Create download link
    const url = window.URL.createObjectURL(finalBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);

    console.log("✅ Download initiated successfully");

    return {
      success: true,
      message: "File downloaded successfully",
      filename: filename,
      size: finalBlob.size
    };

  } catch (error) {
    console.error("❌ Download failed:", error);

    if (error.response?.status === 404) {
      throw {
        response: {
          data: {
            status: "error",
            message: "No processed data found",
            help: "Please process the data first before downloading",
            error_type: "no_processed_data",
            details: { batch_id: batchId }
          }
        }
      };
    }

    handleApiError(error, "Failed to download processed file");
  }
};

/* ========================================================= 
   FORMAT VALIDATION ERRORS FOR UI DISPLAY 
========================================================= */
const formatValidationErrors = (errorResponse) => {
  const data = errorResponse.response?.data;

  if (!data) {
    return "An unknown error occurred";
  }

  let message = data.message || "Validation failed";

  if (data.details?.errors && Array.isArray(data.details.errors)) {
    message += "\n\n" + data.details.errors.map((err, idx) => `${idx + 1}. ${err}`).join("\n");
  }

  if (data.help) {
    message += "\n\n" + data.help;
  }

  return message;
};

/* ========================================================= 
   EXPORT 
========================================================= */
const MainPageModel = {
  handleDownloadSample,
  handleUploadFile,
  handleStartProcess,
  handleDownloadFile,
  validateFile,
  formatValidationErrors,
};

export default MainPageModel;
